import { Corridor, Train, UserPreferences } from '../../models/train-info.model';
import { IOHAppService } from '../../services/ioh-app.service';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ComponentRef,
  Inject,
  ViewContainerRef,
  ChangeDetectorRef,
  effect,
  SimpleChanges,
  Input,
  inject,
  signal,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import {
  Observable,
  Subject,
  Subscription,
  catchError,
  forkJoin,
  of,
  takeUntil
} from 'rxjs';
import { MessageService } from 'primeng/api';
import * as _ from 'lodash';
import { IOHFilterFormService } from '../../services/filter/ioh-filter-form.service';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IOHMapService } from '../../services/ioh-map.service';
import { startPopupShiftWatch } from '../../shared/utils/terminalPopupPosition';
import { ActivatedRoute, Router } from '@angular/router';
import { IOHInfoComponent } from '../ioh-info/ioh-info.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { IOHDynamicDialogService } from '../../shared/service/ioh-dialog.service';
import { BundlePreloadService } from '../../services/bundle-preload.service';
import { MessageModule } from 'primeng/message';
import { IOHLevelComponent } from '../ioh-level/ioh-level.component';
import { IOHFilterComponent } from '../filter/ioh-filter.component';
import { ToastModule } from 'primeng/toast';
import { BundleIOHPreloadService } from 'src/app/services/bundle-loader/ioh-bundle-preload.service';
import { IOHMapComponent } from '../../shared/ioh-map/ioh-map/ioh-map.component';

@Component({
  selector: 'app-ioh-home',
  templateUrl: './ioh-home.component.html',
  styleUrls: ['./ioh-home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MessageModule,
    CommonModule,
    IOHLevelComponent,
    IOHFilterComponent,
    ToastModule,
    IOHMapComponent
  ]
})
export class IOHHomeComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('mapHost') mapHostRef?: ElementRef<HTMLElement>;
  private stopPopupShiftWatch?: () => void;
  iohSelectedTerminal: string = '';
  selectedLevel = 0;
  visible: boolean = false;
  zindex: number = 1;
  clickedData: any;
  flag: boolean = false;
  loading = signal<boolean>(false);
  private ngUnsubscribe = new Subject();
  subscription: Subscription;
  iohLevelLabel: string = 'level-1';
  maskVisible: boolean = true;
  // sidebar data
  iohShowFilter: boolean = false;
  isApiFailed = false;
  queryParams: any = [];
  private destroy$ = new Subject<void>();
  timeInput: string;
  convertedTime: string;
  private dialogComponentRef: ComponentRef<IOHInfoComponent> | null = null;
  private dialogStateSubscription: Subscription | null = null;
  @Input() hostRouteListener: string = '';
  public bundleIOHPreloadService = inject(BundleIOHPreloadService);

  constructor(
    public iohAppService: IOHAppService,
    public iohMapService: IOHMapService,
    private messageService: MessageService,
    private iohFilterFormService: IOHFilterFormService,
    private userPreferencesService: UserPreferencesService,
    private route: ActivatedRoute,
    private router: Router,
    private bundlePreloadService: BundlePreloadService,
    public dialogService: IOHDynamicDialogService,
    private vcr: ViewContainerRef,
    private changeDetector: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>,
    @Inject(DOCUMENT) private document: Document,
    private cdr: ChangeDetectorRef
  ) {
    // Effect for level update
    effect(() => {
      const val = this.iohAppService.iohLevelUpdate$();
      if (val === 2 && this.iohAppService.iohIsTrainIdSearch()) {
        setTimeout(() => {
          const train = this.iohAppService.iohl3Trains$()[0];
          if (train) {
            this.iohMapService.iohZoomToAssetId(
              train.longitude,
              train.latitude,
              11
            );
          } else {
            this.messageService.clear();
            this.messageService.add({
              key: 'missingTrainInMap',
              severity: 'info',
              summary: 'Missing Train Id',
              icon: 'pi pi-exclamation-triangle intermodal-custom-error-toast-icon',
              life: 30000,
              detail: `Unable to view '${this.iohAppService.iohIsTrainIdSearch()}' on ${
                this.iohLevelLabel
              } because it is either at the terminal or its location cannot be determined. `
            });
          }
        }, 100);
      }
    });

    // Effect for mask
    effect(() => {
      this.maskVisible = this.iohAppService.intermodalMask$();
    });

    effect(() => {
      const level = this.iohAppService.iohLevelUpdate$();
      this.iohMapService.setActiveMapSlot(level === 0 ? 'level1' : level === 2 ? 'level3' : null);
    });

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params && params['levelId']) {
        this.iohLevelLabel = params['levelId'];
        let levelNum = 0;
        if (params['levelId'] === 'level-2') {
          levelNum = 1;
        } else if (params['levelId'] === 'level-3') {
          levelNum = 2;
        }
        this.iohAppService.iohLevelUpdate$.set(levelNum);
      }
    });

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(queryParams => {
        this.queryParams = queryParams;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hostRouteListener']) {
      const levelId = this.getLevel(window?.location?.hash);
      if(levelId){
      this.iohAppService.iohLevelUpdate$.set(levelId-1);
      this.iohLevelLabel = `level-${levelId}`;
      }
    }
  }

  //method for level changes
  onLevelChange(event: string) {
    this.iohLevelLabel = event;
    this.router.navigateByUrl(`ioh/level/${event}`, {
      state: { fromPlatform: true },
      skipLocationChange: false
    });
  }

  //on terminal change
  onTerminalChange(event: any) {
    this.iohSelectedTerminal = event;
  }

  //api calls to get data based on polling flad
  getData(isPolling = false) {
    this.messageService.clear();
    this.isApiFailed = false;
    this.iohFilterFormService.isCommodityApiFailed = false;
    this.iohFilterFormService.isTrainGroupApiFailed = false;

    this.getGateInfoData(isPolling);
    this.getIOTrainInfoData(isPolling);
    this.getTerminalInfoData(isPolling);
    this.getNetworkStatsData(isPolling);

    forkJoin([
      this.iohAppService.getIohSystem().pipe(
        catchError(error => {
          console.error('Error while making SYSTEM Api', error);
          return of(null);
        })
      ),
      this.iohAppService.getIohTrainCommodities(!isPolling).pipe(
        catchError(error => {
          console.error('Error while making COMMODITIES Api', error);
          return of(null);
        })
      ),
      this.iohAppService.getIohL3Trains().pipe(
        catchError(error => {
          console.error('Error while making TRAINS L3 Api', error);
          return of(null);
        })
      )
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([systemRes, trainCommodities, L3TrainsData]: [
          any,
          any,
          any
        ]) => {
          let hasError = false;

          if (systemRes === null) {
            hasError = true;
            if (!isPolling) {
              this.apiError('System');
            }
          }

          if (trainCommodities === null) {
            //hasError = true;
            if (!isPolling) {
              this.apiError('Commodities');
            }
          }

          if (!hasError && L3TrainsData === null) {
            if (!isPolling) {
              this.apiErrors(L3TrainsData, {}, {});
              console.error('L3 trains failed');
            }
          }

          if (!hasError) {
            if (!trainCommodities || trainCommodities.length === 0) {
              this.apiError('Commodities');
            }

            const interModelCommodities = trainCommodities?.filter(el => el);
            interModelCommodities?.[Symbol.iterator] &&
              (this.iohFilterFormService.iohCommodityAllFilterOptions = [
                ...interModelCommodities
              ]);

            systemRes?.trains?.forEach(train => {
              train.commodityDesc =
                this.iohFilterFormService.resolveTrainCommodity(train);
            });
            const SystemTrains = systemRes?.trains?.filter(el =>
              this.iohFilterFormService.isIntermodalTrain(el)
            );
            if (systemRes) {
              systemRes.trains = this.combineL3TrainsAndSystemTrains(
                SystemTrains,
                L3TrainsData && L3TrainsData.properties
                  ? L3TrainsData.properties
                  : []
              );
            }

            interModelCommodities?.forEach(trainCommodity => {
              trainCommodity['show'] = systemRes?.trains?.some(
                train => train.commodityDesc === trainCommodity.commodityDesc
              );
            });
            if (systemRes?.corridors?.length)
              systemRes['corridors'] = systemRes?.corridors;
            delete systemRes?.terminals;
            this.iohAppService.iohSystemResponse = systemRes;
            this.iohFilterFormService.commodityFilterOptions = _.cloneDeep(
              _.uniqBy(interModelCommodities, 'commodityDesc')
            );

            if (!isPolling) {
              this.iohFilterFormService.resetFilterFormGroup();
              this.applySavedDefaultFilter();
            } else {
              this.iohFilterFormService.refreshFilterView$.next(true);
            }
          } else if (!this.iohAppService.iohSystemResponse) {
            this.iohAppService.iohSystemResponse = {
              trains: [],
              corridors: []
            } as any;
          }

          this.iohAppService.iohPrepopulateData(
            this.iohAppService.iohSystemResponse,
            isPolling
          );
          this.loading.set(false);
          this.cdr.detectChanges();
        }
      });
  }

  //re-applies the saved default filter after resetFilterFormGroup() rebuilds the form on initial load
  private applySavedDefaultFilter(): void {
    // apply the cached copy synchronously first so counts render once, not twice
    const cached = this.userPreferencesService.loadFromStorage();
    this.applyUserPreferences(cached);

    // sync with the server in the background; only re-apply if it actually differs
    this.userPreferencesService
      .getUserPreferences()
      .pipe(
        catchError(() => of(null)),
        takeUntil(this.destroy$)
      )
      .subscribe(serverPrefs => {
        if (
          serverPrefs &&
          JSON.stringify(serverPrefs) !== JSON.stringify(cached)
        ) {
          this.applyUserPreferences(serverPrefs);
        }
      });
  }

  private applyUserPreferences(userPrefs: UserPreferences | null): void {
    const savedFilter = userPrefs?.filters?.semanticFilter;
    if (savedFilter && Object.keys(savedFilter).length > 0) {
      this.iohFilterFormService.setFilterPreferenceResponse(savedFilter);
    }
    this.iohFilterFormService.dataReady$.next();
  }

  getGateInfoData(isPolling: boolean): void {
    this.iohAppService
      .getIohGateInfo()
      .pipe(
        catchError(error => {
          console.error('Error while making Gate Info Api', error);
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(gateInfo => {
        if (gateInfo === null) {
          this.iohAppService.iohGateInfo$.set(null);
          if (!isPolling) {
            this.apiErrors({}, gateInfo, {});
          }
          return;
        }

        this.iohAppService.iohGateInfo$.set(gateInfo);
        this.cdr.detectChanges();
      });
  }

   getIOTrainInfoData(isPolling: boolean): void {
    this.iohAppService
      .getIohIOTrainInfo()
      .pipe(
        catchError(error => {
          console.error('Error while making Train Info Api', error);
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(ioTrainInfo => {
        if (ioTrainInfo === null) {
          this.iohAppService.iohTrainInfo$.set(null);
          if (!isPolling) {
            this.apiErrors({}, {}, ioTrainInfo);
          }
          return;
        }

        this.iohAppService.iohTrainInfo$.set(ioTrainInfo);
         this.cdr.detectChanges();
      });
  }

  getTerminalInfoData(isPolling: boolean): void {
    this.iohAppService
      .getIohTerminalInfo(!isPolling)
      .pipe(
        catchError(error => {
          console.error('Error while making TERMINAL INFO Api', error);
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(terminalInfo => {
        if (terminalInfo === null) {
          this.iohAppService.iohTerminalInfoFromApi = [];
          this.iohAppService.iohTerminalInfoList = [];
          this.iohAppService.iohTerminalInfoRaw$.set([]);
          if (!isPolling) {
            this.apiErrors({}, {}, {}, null, {});
          }
          return;
        }

        this.iohAppService.iohTerminalInfoFromApi =
          this.iohAppService.iohBuildTerminalsFromApi(terminalInfo);
        if (this.iohAppService.iohSystemResponse) {
          this.iohAppService.iohPrepopulateData(
            this.iohAppService.iohSystemResponse,
            isPolling
          );
        }
        this.cdr.detectChanges();
      });
  }

  getNetworkStatsData(isPolling: boolean): void {
    this.iohAppService
      .getIohNetworkStats()
      .pipe(
        catchError(error => {
          console.error('Error while making NETWORK STATS Api', error);
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(networkStats => {
        if (networkStats === null) {
          this.iohAppService.iohNetworkStats$.set(null);
          if (!isPolling) {
            this.apiErrors({}, {}, {}, {}, null);
          }
          return;
        }

        this.iohAppService.iohNetworkStats$.set(networkStats);
        this.cdr.detectChanges();
      });
  }

  //method for combining train data with system train api response
  combineL3TrainsAndSystemTrains(
    systemTrains: Train[],
    iohl3Trains: any[]
  ): Train[] {
    const l3Map = new Map(
      iohl3Trains.map(l3Train => [l3Train.trainId, l3Train])
    );

    return systemTrains?.map(train => {
      const l3Train = l3Map.get(train.trainId);
      return l3Train ? { ...l3Train, ...train } : train;
    });
  }

  //to create ioh info dialog
  createDialogComponent() {
    if (!this.dialogComponentRef) {
      // Remove any stale dialog hosts left behind from a previous component instance.
      // this.document.querySelectorAll('csx-ioh-info').forEach(host => {
      //   host.remove();
      // });
      this.dialogComponentRef = this.vcr.createComponent(IOHInfoComponent);
      this.document.body.appendChild(
        this.dialogComponentRef.location.nativeElement
      );
      this.dialogComponentRef.instance.isVisibleOutputEventEmitter.subscribe(
        (isVisible: boolean) => {
          if (!isVisible) {
            this.dialogService.hideDialog();
          }
        }
      );
    }
  }

  //to destroy ioh diogs on rtop switch
  destroyDialogComponent() {
    if (
      this.dialogComponentRef &&
      this.dialogComponentRef.location.nativeElement.parentNode ===
        this.document.body
    ) {
      this.document.body.removeChild(
        this.dialogComponentRef.location.nativeElement
      );
      this.dialogComponentRef.destroy();
      this.dialogComponentRef = null;
    }
  }

  ngAfterViewInit(): void {
    this.iohMapService.registerMapHost(this.mapHostRef?.nativeElement ?? null);
    this.stopPopupShiftWatch = startPopupShiftWatch(this.elementRef.nativeElement, (dx, dy) =>
      this.iohAppService.correctOpenPopupAnchors(dx, dy, this.iohShowFilter)
    );
  }

  ngOnInit() {
    this.bundleIOHPreloadService.preloadIohRealtimeInfoDetails();
    this.isApiFailed = false;
    this.loading.set(true);
    this.getData();
    this.iohAppService.createEventSourceObserver().subscribe(res => {
      this.iohAppService.iohEquipmentInfo$.set(res);
    });
    this.startPolling();
    if (this.dialogStateSubscription) {
      this.dialogStateSubscription.unsubscribe();
    }
    this.dialogStateSubscription = this.dialogService.dialogState$.subscribe(
      subcribedData => {
        if (subcribedData.visible) {
          if (!this.dialogComponentRef) {
            this.createDialogComponent();
          }
          this.dialogComponentRef.instance.isVisible = subcribedData.visible;
          this.dialogComponentRef.instance.terminalCode = subcribedData.data;
          this.dialogComponentRef.changeDetectorRef.detectChanges();
        } else {
          this.destroyDialogComponent();
        }
      }
    );

    this.bundlePreloadService.preloadRealtimeTrainDetails();
    this.router.initialNavigation();
  }

  //to poll data based on falg
  pollData() {
    this.getData(true);
  }

  //to start polling
  startPolling() {
    const pollingInterval = interval(environment.appConfig.refreshInterval);
    this.subscription = pollingInterval
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.pollData();
      });
  }

  //to stop polling
  stopPolling() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  //to handle api error for Commodities & System apis
  apiError(type: string) {
    if (type === 'Commodities') {
      this.iohFilterFormService.commodityFilterOptions = [];
      this.iohFilterFormService.iohCommodityAllFilterOptions = [];
      this.iohFilterFormService.isCommodityApiFailed = true;
    } else if (type === 'System') {
      this.isApiFailed = true;
      this.messageService.add({
        key: 'systemerror',
        severity: 'error',
        summary: 'Error',
        detail: `Something went wrong with System API. Please try again later.`
      });
      this.changeDetector.detectChanges();
    }
  }

  apiErrors(train, iogate, iotrains, terminalInfo = {}, networkStats = {}) {
      const nullFields = [];
      if (train === null) nullFields.push('Level 3 Trains');
      if (iogate === null) nullFields.push('Gate');
      if (iotrains === null) nullFields.push('Inbound/Outbound Trains');
      if (terminalInfo === null) nullFields.push('Terminal Info');
      if (networkStats === null) nullFields.push('Network Stats');
      let errorMsg = nullFields.join(',');
      this.messageService.add({
        key: 'systemerror',
        severity: 'error',
        summary: 'Error',
        detail:  `${errorMsg} data failed to load. Please retry after some time.`
      });
      this.changeDetector.detectChanges();
  }

  //on show filter click
  showFilterChange(event) {
    this.iohShowFilter = event;
  }

  getLevel(url) {
    const m = url.match(/ioh\/level\/level-(\d+)/); // ensures the path exists
    return m ? Number(m[1]) : null;                 // returns integer or null
  }

  mapHostStyle() {
    const id = this.iohMapService.activeMapSlot();
    if (!id) return { display: 'none' };
    return {
      display: 'block',
      width: '100%',
      height: '100%',
      visibility: this.iohMapService.mapViewSettled() && !this.loading() ? 'visible' : 'hidden',
      'z-index': this.iohAppService.iohLevelUpdate$() === 0 ? 1 : 10
    };
  }

  ngOnDestroy(): void {
    if (this.dialogStateSubscription) {
      this.dialogStateSubscription.unsubscribe();
      this.dialogStateSubscription = null;
    }
    this.destroyDialogComponent();
    this.dialogService.hideDialog();
    this.stopPolling();
    this.ngUnsubscribe.complete();
    this.destroy$.next();
    this.destroy$.complete();
    // Clear any DOM references
    const dialogs = document.querySelectorAll('p-dialog');
    dialogs.forEach(dialog => {
      if (dialog) {
        (dialog as HTMLElement).style.display = 'none';
      }
    });
    this.iohAppService.iohSetTrainIdForSearch('');
    this.iohAppService.iohl3Trains$.set(null);
    this.iohAppService.iohEquipmentInfo$.set(null);
    this.iohAppService.iohEquipmentInfoWc$.set(null);
    this.iohAppService.iohResetTerminalPopupState();
    this.iohMapService.resetIohMapService();
    this.stopPopupShiftWatch?.();
    this.iohAppService.killSSE();
    this.iohAppService.iohEquipmentInfo$.set(null);
    this.iohAppService.iohEquipmentInfoWc$.set(null);
  }
}
